import React from 'react'
import styles from './ProgressCards.module.css'
// import { LazyLoadImage } from 'react-lazy-load-image-component';

export default function ProgressList({ img, place, value, color, total_value, fontSize = '16px' }) { 
    const percentage = 100-(total_value - value) / total_value * 100; // Calculate the percentage
  
    return (
      <div className={styles.container}>

        <img className={styles.img} src={img} alt="Description of the image" />
        {/* <LazyLoadImage
      className={styles.img}
      alt={"Description of the image"}
      src={img} // use normal <img> attributes as props
      effect="blur"
      /> */}
    
        <p className={styles.title} style={{ fontSize }}>
          {place}
          <hr style={{ backgroundColor: color, width: `${percentage}%` }} className={styles.hr_progress} />
          <p className={styles.percentage_value}>{Math.round(percentage)}%</p>

          <hr className={styles.hr_base} />
        </p>
        <p className={styles.value}>{value.toLocaleString()}</p>
      </div>
    );
  }